export class VerifyIdentityModel {
    public TwoFactorOptionsDescription: string;
}
